export enum DefaultFieldTypeStatusEnum {
	Appointment = 'Appointment',
	Project = 'Project',
}

export const DefaultFieldTypeStatusArray = [DefaultFieldTypeStatusEnum.Appointment, DefaultFieldTypeStatusEnum.Project];
